export const corpus = {
    accessMatrix: {
        research: {
            add: ['learner', 'trainer', 'manager', 'administrator'],
            edit: ['trainer', 'manager', 'administrator'],
            editOwn: ['learner'],
            delete: ['trainer', 'manager', 'administrator'],
            deleteOwn: ['learner']
        },
        lesson: {
            add: ['trainer', 'manager', 'administrator'],
            edit: ['trainer', 'manager', 'administrator'],
            editOwn: [],
            delete: ['trainer', 'manager', 'administrator'],
            deleteOwn: []
        },
        global: {
            view: ['learner', 'trainer', 'manager', 'administrator'],
            add: ['manager', 'administrator'],
            edit: ['manager', 'administrator'],
            delete: ['manager', 'administrator'],
            selectAll: ['learner', 'trainer', 'manager', 'administrator']
        },
        userCorpus: {
            view: ['learner', 'trainer', 'manager', 'administrator'],
            add: ['manager', 'administrator'],
            edit: ['manager', 'administrator'],
            delete: ['manager', 'administrator'],
            selectAll: ['learner', 'trainer', 'manager', 'administrator']
        }
    },
    addToLesson: true,
    allowedExtensions: 'jpg, jpeg, png, gif, mp4, mpeg, mp3, pdf',
    allowErrorReporting : true,
    assetFields : {
        manager : ['educationalLevel', 'language', 'chapters', 'concepts', 'tags'],
        trainer : ['source', 'description'],
        default : ['name', 'author', 'source', 'description']
    },
    assetRequiredFields: ['name'],
    authorRolesGeneralCorpus: ['3', '4', '5'], // 3 => administrator, 4 => gestionnaire, 5 => formateur, 6 => apprenant
    columns: {
        administrator: ['checkbox', 'icon', 'title', 'level', 'changedDate', 'learningTime', 'detail-button'],
        manager: ['checkbox', 'icon', 'title', 'level', 'changedDate', 'learningTime', 'detail-button', 'buttonsAction'],
        default: ['checkbox', 'icon', 'title', 'level', 'learningTime', 'detail-button']
    },
    detailsFields: ['learning-time', 'concepts', 'chapters', 'levels', 'difficulty', 'skills', 'indexation'],
    fileMaxSize: '1',
    filesWhiteList: [
        'image/jpg',
        'image/jpeg',
        'image/png',
        'image/gif',
        'video/mp4',
        'video/mpeg',
        'audio/mp3',
        'audio/mpeg',
        'application/pdf'
    ],
    filters: {
        administrator: ['chapters', 'keywords', 'type', 'title', 'source', 'concepts', 'launchSearch'],
        manager: ['chapters', 'keywords', 'type', 'title', 'source', 'concepts', 'launchSearch'],
        default: ['chapters', 'keywords', 'type', 'title', 'concepts', 'launchSearch']
    },
    formatImg: '.jpg, .jpeg, .png, .gif',
    globalCorpus: '11057',
    mediaTypes: ['audio', 'document', 'image', 'text', 'url', 'video'], // 'audio', 'document', 'image', 'media', 'text',  'url', 'video', 'videoUrl'
    showButtonOptions: true,
    terms: {
        globalCorpus:  {
            title: 'corpus.title',
            columns: {
                type: 'generic.type',
                author: 'generic.author',
                group: 'generic.group',
            }
        },
        research: {
            title: 'projects-management.research_space',
            columns: {
                type: 'generic.type',
                author: 'generic.author',
                group: 'generic.group',
            }
        },
        lesson: {
            title: 'generic.title_lesson_corpus',
            columns: {
                type: 'generic.type',
                author: 'generic.author',
                group: 'generic.group',
            }
        },
    },
    // TODO FOR ALL INSTANCE ADD THIS AND CHECK THEY USE ONLY THIS FIELDS
    userCorpus: false, // define if there is a corpus to list current user assets
    displayHeader: true,
};
